import { connect } from 'react-redux';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import { Instances } from '../../../../constants';
import { IStateType } from '../../../../store/models/root.interface';
import { makeSelectInProgress } from '../../../../store/Object';
import { makeSelectObjectsArray, requestObjects } from '../../../../store/Objects';
import { closeSideBar, getParams } from '../../../../store/sidebar';
import ViewTemplateDetails, { DispatchPropsType, MapStateType } from '../organisms/templates/viewTemplateDetails';

const mapStateToProps = (state: IStateType) => ({
    whatsappTemplate: makeSelectObjectsArray(Instances.viewWhatsappTemplate)(state) || [],
    inProgress: makeSelectInProgress(Instances.smsSenderIdView)(state),
    params: getParams(state)
});

const mapDispatchToProps = (dispatch: any) => ({
    onClose: () => dispatch(closeSideBar()),
    onLoad: (param: any) => dispatch(requestObjects(Instances.viewWhatsappTemplate, { temp: param.id })),
});

export default connect<MapStateType, DispatchPropsType, unknown, IStateType>(
    mapStateToProps,
    mapDispatchToProps
)(withImmutablePropsToJS(ViewTemplateDetails));